import React from "react";
import faceChangePNG from "./imgs/faceChange.png";
import tornadoPNG from "./imgs/tornado.png";
import welcomePNG from "./imgs/welcome.png";
import cryPNG from "./imgs/cry.png";
import arrowPNG from "./imgs/arrow.png";
import smilePNG from "./imgs/smile.png";
import emptyPNG from "./imgs/empty.png";
import heartPNG from "./imgs/heart.png";
import bombPNG from "./imgs/bomb.png";
import skatePNG from "./imgs/skate.png";
import celebratePNG from "./imgs/celebrate.png";

interface IconProps {
    color?: string;
    className?: string;
    onClick?: () => void;
}

export const FaceChangeIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={faceChangePNG} />
);
export const TornadoIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={tornadoPNG} />
);
export const WelcomeIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={welcomePNG} />
);
export const CryIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={cryPNG} />
);
export const EmptyIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={emptyPNG} />
);
export const HeartIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={heartPNG} />
);
export const BombIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={bombPNG} />
);
export const SkateIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={skatePNG} />
);
export const CelebrateIcon: React.FC<IconProps> = ({ className }) => (
    <img className={className} src={celebratePNG} />
);

export const TornadoIconPNG = tornadoPNG;
export const FaceChangeIconPNG = faceChangePNG;
export const CryIconPNG = cryPNG;
export const WelcomeIconPNG = welcomePNG;
export const SmileIconPNG = smilePNG;
export const ArrowIconPNG = arrowPNG;
export const EmptyIconPNG = emptyPNG;
export const HeartIconPNG = heartPNG;
export const BombIconPNG = bombPNG;
export const SkateIconPNG = skatePNG;
export const CelebrateIconPNG = celebratePNG;
